import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const PreserveProfitLine = observer(({
  tradePlanId,
  state,
  priceToBreak,
  amount,
  size,
  scaleY,
  portalRef,
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['PRESERVE_PROFIT']?.paused ?? null;

  const json = {
    Category: 'Exit Tactic',
    Type: 'Preserve Profit',
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
    Amount: amount,
  };
  return (
    <>
      {scaleY ? (
        <>
          {paused ? (
            <line
              strokeDasharray={4}
              stroke={state === 'wait' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          ) : (
            <line
              stroke={state === 'wait' ? colors.orange : colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          )}

          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
});

PreserveProfitLine.propTypes = {
  state: PropTypes.any,
  priceToBreak: PropTypes.number,
  amount: PropTypes.number,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any,
};
